// Add your custom JS here.

// Mega Menu Logic
(function ($) {
  $(document).ready(function () {
    $('.main-nav__dropdown-link .dropdown__close').on('keypress', function (e) {
      if (e.which == 13 || e.which == 32) {
        $(e.currentTarget).trigger('click');
      }
    });
    

    $('.header__navigation-menus .main-nav__dropdown-link').on('click', function (e) {
      e.preventDefault();

      var $target = $(e.currentTarget);
      var $dropdownTarget = $('#' + $target.attr('data-dropdown'));

      if ($target.hasClass('active')) {

        $('.header__navigation-menus .main-nav__dropdown-link').removeClass('transition-active active');
        $('.header__navigation-menus .dropdown').removeClass('transition-active active');

      } else {

        $('.header__navigation-menus .main-nav__dropdown-link').removeClass('active');
        $('.header__navigation-menus .dropdown').removeClass('active');

        $target.toggleClass('transition-active');
        $dropdownTarget.toggleClass('transition-active');

        setTimeout(function () {
          $target.toggleClass('transition-active active');
          $dropdownTarget.toggleClass('transition-active active');
        }, (0));

      }
    });

    $('.dropdown__close, .dropdown__backdrop').on('click', function () {
      $('.main-nav__dropdown-link').removeClass('active');
      $('.dropdown').removeClass('active');
    });

    $('.mobile-menu .main-nav__dropdown-link').on('click', function (e) {
      e.preventDefault();

      var $target = $(e.currentTarget);
      var $dropdownTarget = $('#' + $target.attr('data-dropdown'));

      if ($target.hasClass('active')) {

        $('.mobile-menu .main-nav__dropdown-link').removeClass('transition-active active');
        $target.parent().find('.dropdown').removeClass('transition-active active');

      } else {

        $('.mobile-menu .main-nav__dropdown-link').removeClass('active');
        $target.parent().parent().find('.dropdown').removeClass('transition-active active');
        $target.parent().find('.dropdown').addClass('transition-active active');

        $target.toggleClass('transition-active');
        $dropdownTarget.toggleClass('transition-active');

        setTimeout(function () {
          $target.toggleClass('transition-active active');
          $dropdownTarget.toggleClass('transition-active active');
        }, (0));

      }
    });

    $('.hamburger-menu-toggle').click(function () {
      if ($(this).hasClass('menu-opened')) {
        $(this).removeClass('menu-opened');
        $('.mobile-menu').removeClass('menu-opened');
      } else {
        $(this).addClass('menu-opened');
        $('.mobile-menu').addClass('menu-opened');
      }
    });

    // search
    $('header .header__content .search-wrp').click(function () {

      if (!$('header .search-container').hasClass('search-show')) {
        $('header .search-container').addClass('search-show');
        $(this).addClass('search-show');
      } else {
        $('header .search-container').removeClass('search-show');
        $(this).removeClass('search-show');
      }

    });

    $('header .mobile-menu-wrp .mobile-search-wrp').click(function () {

      if (!$('header .search-container').hasClass('search-show')) {
        $('header .search-container').addClass('search-show');
        $(this).addClass('search-show');
      } else {
        $('header .search-container').removeClass('search-show');
        $(this).removeClass('search-show');
      }

    });

    $('header .search-container .search-close').click(function () {
      $('header .search-container').removeClass('search-show');
      $('header .header__content .search-wrp').removeClass('search-show');
    });

    $('header .search-container .search-wrp .search-icon').click(function () {
      $('header .search-container .search-wrp .search-form-wrp form').submit();
    });

    // Featured Products Slider
    if ($('.sp-featured-products-section .products-slider, .sp-featured-products .products-slider').length) {
      $('.sp-featured-products-section .products-slider, .sp-featured-products .products-slider').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        // autoplay: true,
        // autoplaySpeed: 3000,
        infinite: true,
        arrows: true,
        dots: false,
        adaptiveHeight: true,
        responsive: [{
          breakpoint: 992,
          settings: {
            slidesToShow: 2
          }
        }, {
          breakpoint: 768,
          settings: {
            slidesToShow: 2
          }
        }, {
          breakpoint: 576,
          settings: {
            slidesToShow: 1
          }
        }]
        
      });

      $('.sp-featured-products-section .slick-prev, .sp-featured-products .slick-prev').attr('aria-label', 'Previous slide');
      $('.sp-featured-products-section .slick-next, .sp-featured-products .slick-next').attr('aria-label', 'Next slide');
    }

    if ($('.single-product-page .product-gallery-part .top-slider').length) {
      $('.single-product-page .product-gallery-part .top-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        // autoplay: false,
        autoplaySpeed: 3000,
        speed: 200,
        infinite: true,
        arrows: true,
        dots: false,
        asNavFor: '.single-product-page .product-gallery-part .thumbnail-slider'
      });

      $('.single-product-page .product-gallery-part .thumbnail-slider').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        // autoplay: false,
        autoplaySpeed: 3000,
        speed: 200,
        infinite: true,
        arrows: false,
        dots: false,
        asNavFor: '.single-product-page .product-gallery-part .top-slider',
      });

      $('.single-product-page .product-gallery-part .thumbnail-slider .slick-slide').click(function (e) {
        var slideno = $(this).data('slick-index');
        $('.single-product-page .product-gallery-part .thumbnail-slider').slick('slickGoTo', slideno);
      });

    }

    if ($('.single-product-page .product-gallery-modal .top-slider').length) {
      $('.single-product-page .product-gallery-modal .top-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        // autoplay: false,
        autoplaySpeed: 3000,
        speed: 200,
        infinite: true,
        arrows: true,
        dots: false,
        asNavFor: '.single-product-page .product-gallery-modal .thumbnail-slider'
      });

      $('.single-product-page .product-gallery-modal .thumbnail-slider').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        // autoplay: false,
        autoplaySpeed: 3000,
        speed: 200,
        infinite: true,
        arrows: false,
        dots: false,
        asNavFor: '.single-product-page .product-gallery-modal .top-slider',
      });

      $('.single-product-page .product-gallery-modal .thumbnail-slider .slick-slide').click(function (e) {


        e.preventDefault();
        var slideno = $(this).data('slick-index');
        $('.single-product-page .product-gallery-modal .thumbnail-slider').slick('slickGoTo', slideno);
      });

    }

    $('.single-product-page .product-gallery-part .expand-icon').click(function () {
      $('#exampleModal').modal('show');

      $('#exampleModal').on('shown.bs.modal', function () {
        var $topSlider = $('.single-product-page .product-gallery-modal .top-slider');
        var $thumbnailSlider = $('.single-product-page .product-gallery-modal .thumbnail-slider');

        $topSlider.slick('setPosition').slick('refresh');
        $thumbnailSlider.slick('setPosition').slick('refresh');

        if ($topSlider.find('.slick-slide').length === 1) {
          $topSlider.slick('slickGoTo', 0);
        }

        $thumbnailSlider.find('.slick-slide').off('click').on('click', function (e) {
          e.preventDefault();
          var slideno = $(this).data('slick-index');
          $thumbnailSlider.slick('slickGoTo', slideno);
        });
      });
    });




    $('.fb-button').on('click', function () {
      $('.step-1').hide();
      $('.step-2').show();
    });

    $('.back-button').on('click', function () {
      $('.step-2').hide();
      $('.step-1').show();
    });

    // accordion
    $('.accordion__header').on('click', function () {
      let $item = $(this).closest('.accordion__item');
      let $content = $item.find('.accordion__content');
      $content.slideToggle(300, function () {
        $item.toggleClass('acc-open', $content.is(':visible'));
      });
    });


  function addMenuActive() {
    const currentURL = new URL(location.href);
    const currentPathname = getFinalPathSegment(currentURL.pathname); 
    const currentSearchParams = currentURL.search;

    if (!currentPathname) return;

    $('#main-navigation li').each(function () {
        const $li = $(this);
        const $topLink = $li.find('> a.main-nav__top-link');
        let isActive = false;

        if ($topLink.length) {
            const linkURL = new URL($topLink.attr('href'), location.origin);
            const linkPathname = getFinalPathSegment(linkURL.pathname);

            if (currentPathname === linkPathname || checkPartialMatch(currentPathname, linkPathname)) {
                isActive = true;
            }
        }

        $li.find('.dropdown__right__column a').each(function () {
            const nestedLinkURL = new URL($(this).attr('href'), location.origin);
            const nestedLinkPathname = getFinalPathSegment(nestedLinkURL.pathname);

            if (currentPathname === nestedLinkPathname || checkPartialMatch(currentPathname, nestedLinkPathname)) {
                isActive = true;
                return false;
            }
        });
        $li.find('.dropdown__left a').each(function () {
          const leftLinkURL = new URL($(this).attr('href'), location.origin);
          const leftLinkPathname = getFinalPathSegment(leftLinkURL.pathname);

          if (currentPathname === leftLinkPathname || checkPartialMatch(currentPathname, leftLinkPathname)) {
              isActive = true;
              return false;
          }
      });

        if (isActive) {
            $topLink.addClass('current-page');
        }
    });
}

  function getFinalPathSegment(pathname) {
      const cleanedPath = pathname.replace(/[#?].*$/, '');
      const segments = cleanedPath.split('/').filter(Boolean);
      return segments.length ? segments[segments.length - 1] : '';
  }

  function checkPartialMatch(currentPath, linkPath) {
      if (!currentPath || !linkPath) return false;

      const currentSegments = currentPath.split('/');
      const linkSegments = linkPath.split('/');

      return currentSegments[currentSegments.length - 1] === linkSegments[linkSegments.length - 1];
  }

addMenuActive();


    $('.icon-play').on('click', function () {
      $(this).removeClass('icon-play');
      let video = $(this).find('video')[0];
      if (video) {
        video.setAttribute('controls', 'controls');
      }
    });


    // default modal open
    $('.open-modal').on('click', function (e) {
        e.preventDefault();
        const modalId = $(this).data('modal');
        const targetModal = $(`#${modalId}`);
        targetModal.addClass('open');
        $('body').css('overflow', 'hidden');
    });

    // Close modal
    $(document).on('click', '.product-modal', function (e) {
        const modal = $(this);
        if ($(e.target).is(modal) || $(e.target).hasClass('modal-close')) {
            modal.removeClass('open');
            $('body').css('overflow', '');
        }
    });

    // pardot iframe auto height
    if ( jQuery('#pardot-iframe').length ) {
      jQuery('#pardot-iframe').seamless({
        fallbackText: ''
      });
    }

  });


  $('#load-more-products').on('click', function () {
    let button = $(this),
        categories = JSON.parse(button.attr('data-category')),
        offset = parseInt(button.attr('data-offset')),
        total = parseInt(button.attr('data-total')),
        nonce = button.attr('data-nonce'),
        postsPerLoad = 3;

    $.ajax({
        url: ajax_object.ajaxurl,
        type: 'POST',
        data: {
            action: 'load_more_products',
            categories: categories,
            offset: offset,
            posts_per_load: postsPerLoad,
            nonce: nonce
        },
        beforeSend: function () {
            button.css('opacity', '0.6');
        },
        success: function (response) {
            if (response.success) {
                $('.sp-featured-products').append(response.data);
                offset += postsPerLoad;
                button.attr('data-offset', offset);

                if (offset >= total) {
                    button.hide();
                } else {
                    button.css('opacity', '1');
                }
            } else {
                console.error('Error:', response.data);
                button.hide();
            }
        },
        error: function (xhr, status, error) {
            console.error('AJAX error:', status, error);
        }
    });
});

  $('.sp-faq__question').click(function() {
    const content = $(this).next('.sp-faq__content'); 
    const parentItem = $(this).closest('.sp-faq__item');

    if (content.is(':visible')) {
        content.slideUp(250);
        parentItem.removeClass('active');
    } else {
        content.slideDown(250);
        parentItem.addClass('active');
    }
});
})(jQuery);